// extracted by mini-css-extract-plugin
export default {"label":"ToggleLabel_label__Fm4pJ"};